import stipulate from 'stipulate';
import urlJoin from 'url-join';
import { baseUrl } from './base';

const lookupDomainsAvailability = function (options) {
  const url = urlJoin(
    options.apiUrl,
    baseUrl,
    '/pb/lookup-domains-availability/'
  );

  const requestBody = { 'search_string': options.searchString };
  if (options.searchKey) {
    requestBody.search_key = options.searchKey;
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(requestBody),
  };
  if (options.signal) {
    fetchOptions.signal = options.signal;
  }
  return stipulate(url, fetchOptions);
};

export default lookupDomainsAvailability;
